<template>
  <!-- 无内容 -->
  <div class="outer">
    <img class="null_" src="~@/assets/image/common/noh.webp" alt="null" />
    <div>没有查询到相关内容噢</div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.outer {
  width: 150px;
  margin: 50px auto 0;
  color: #ccc;
  font-size: 14px;
}
.null_ {
  height: 120px;
  width: auto;
  margin-bottom: 10px;
}
</style>
